import { type SidebarSection } from '@/types/config'
import { BankIcon, CupIcon, FrameIcon, HomeIcon, MoneysIcon, ProfileUsersIcon, UserOctagonIcon } from '@/components/layout/sidebar-icons'
import { Becy } from '@/components/ui/icon'

const SPORT_TAB_ICON = '/images/football.png'
const CASINO_TAB_ICON = '/images/ace.png'

export const SECTION_TABS = [
	{
		key: 'sport' as const,
		label: 'Sport',
		icon: SPORT_TAB_ICON,
		gradient: {
			start: 'var(--accent-green)',
			end: 'var(--accent-blue)',
		},
		logoBackground:
			'bg-[radial-gradient(ellipse_50%_100%_at_50%_-25%,transparent_0%,hsl(var(--background))_100%),linear-gradient(90deg,hsl(var(--accent-green)),hsl(var(--accent-blue)))]',
		background: {
			active: 'bg-[radial-gradient(circle_100px_at_50%_120%_in_hsl_shorter_hue,transparent_0%,hsl(var(--background))_60%),linear-gradient(90deg,hsl(var(--accent-green))_0%,hsl(var(--accent-blue))_100%)] shadow-[0_0_18px_hsl(var(--accent-green)/0.16),0_0_24px_hsl(var(--secondary))]',
			inactive:
				'bg-[radial-gradient(circle_100px_at_50%_120%_in_hsl_shorter_hue,transparent_0%,hsl(var(--background))_50%),linear-gradient(180deg,hsl(var(--accent-green)/0.2)_0%,hsl(var(--accent-blue)/0.2)_100%)]',
		},
	},
	{
		key: 'casino' as const,
		label: 'Casino',
		icon: CASINO_TAB_ICON,
		gradient: {
			start: 'var(--accent-pink)',
			end: 'var(--accent-purple)',
		},
		logoBackground:
			'bg-[radial-gradient(ellipse_50%_100%_at_50%_-25%,transparent_0%,hsl(var(--background))_100%),linear-gradient(90deg,hsl(var(--accent-pink)),hsl(var(--accent-purple)))]',
		background: {
			active: 'bg-[radial-gradient(circle_100px_at_50%_120%_in_hsl_shorter_hue,transparent_0%,hsl(var(--background))_60%),linear-gradient(90deg,hsl(var(--accent-pink))_0%,hsl(var(--accent-purple))_100%)] shadow-[0_0_18px_hsl(var(--accent-pink)/0.16),0_0_24px_hsl(var(--secondary))]',
			inactive:
				'bg-[radial-gradient(circle_100px_at_50%_120%_in_hsl_shorter_hue,transparent_0%,hsl(var(--background))_50%),linear-gradient(180deg,hsl(var(--accent-pink)/0.2)_0%,hsl(var(--accent-purple)/0.2)_100%)]',
		},
	},
] satisfies {
	key: SidebarSection
	label: string
	icon: string
	gradient: { start: string; end: string }
	logoBackground: string
	background: { active: string; inactive: string }
}[]

export const DEFAULT_SIDEBAR_LOGO_BACKGROUND =
	'bg-[radial-gradient(ellipse_50%_100%_at_50%_-25%,transparent_0%,hsl(var(--background))_100%),linear-gradient(90deg,hsl(var(--accent-green)),hsl(var(--accent-blue)))]'

export const NAV_ITEMS = [
	{ key: 'dashboard', label: 'Dashboard', icon: FrameIcon, to: '/dashboard' },
	{ key: 'home', label: 'Home', icon: HomeIcon, to: '/' },
	{
		key: 'becy-originals',
		label: 'BECY Originals',
		icon: Becy,
		to: '/becy-originals',
	},
	{ key: 'staking', label: 'Staking', icon: BankIcon, to: '/staking' },
	{
		key: 'affiliate',
		label: 'Affiliate System',
		icon: UserOctagonIcon,
		to: '/affiliate',
	},
	{
		key: 'p2p-legends',
		label: 'P2P Legends',
		icon: ProfileUsersIcon,
		to: '/p2p-legends',
	},
	{ key: 'vip-club', label: 'VIP Club', icon: CupIcon, to: '/vip-club' },
	{
		key: 'buy-sell',
		label: 'BECY Buy / Sell',
		icon: MoneysIcon,
		to: '/buy-sell',
	},
]
